import React from "react";
import { Header, Segment, Button, List } from "semantic-ui-react";
import { connect } from "react-redux";
import EventLog from "../components/EventLog";
import Slider from "./Slider";
import { withTranslation } from "react-i18next";

class CurrentUserDetails extends React.Component {
  render() {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Header as="h2" style={{ margin: 0, padding: "4px 12px" }}>
          {this.props.roomTitle || this.props.t("CreateRoom.roomTitle")}
        </Header>

        <Segment attached style={{ padding: 0 }}>
          <div style={{ padding: "10px 12px", borderBottom: "1px solid rgba(34, 36, 38, 0.15)" }}>
            <Slider
              label={this.props.t("ProctoringSession.cycleMaxUsers")}
              min={0}
              max={30}
              updateMaxUserCycleTime={this.props.updateMaxUserCycleTime}
              maxUserCycleTime={this.props.maxUserCycleTime}
              disabled={this.props.cycleDisabled}
            />
          </div>

          <div style={{ padding: "10px 12px", borderBottom: "1px solid rgba(34, 36, 38, 0.15)", display: "flex", flexDirection: "column", gap: 8 }}>
            <Button
              circular
              size="mini"
              icon={this.props.allMuted ? "unmute" : "mute"}
              content={this.props.allMuted ? "Unmute all" : "Mute all"}
              onClick={this.props.onMuteAll}
              className="flat-button flat-button-primary"
            />
            <Button
              circular
              size="mini"
              icon={this.props.chatNotificationsMuted ? "bell" : "bell slash"}
              content={
                this.props.chatNotificationsMuted
                  ? "Unmute all chat notifications"
                  : "Mute all chat notifications"
              }
              onClick={this.props.onMuteAllChatNotifications}
              className="flat-button flat-button-primary"
            />
            <Button
              circular
              size="mini"
              icon="linkify"
              content="Send Link to all"
              onClick={this.props.onSendLinkToAll}
              className="flat-button flat-button-primary"
            />
          </div>

          <div style={{ padding: 0 }}>
          <Header as="h2" attached="top" style={{ margin: 0 }}>
            Active Proctors
          </Header>
          <List relaxed divided size="small" style={{ margin: 0, padding: "6px 12px" }}>
            {(this.props.proctors || []).map((proctor) => (
              <List.Item key={proctor.id || proctor.username} style={{ padding: "4px 0" }}>
                <List.Content>
                  <List.Header style={{ fontSize: 13 }}>{proctor.name || proctor.username}</List.Header>
                </List.Content>
              </List.Item>
            ))}
          </List>
          </div>
        </Segment>

        <div style={{ flex: 1, minHeight: 0 }}>
          <EventLog
            events={this.props.events}
            header={this.props.t("general.eventLog")}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  connect((state) => ({
    maximizedUser: state.session.maximizedUser,
    currentExam: state.session.currentExam,
    events: state.session.events,
  }))(CurrentUserDetails)
);
